<div class="welcome-dialog">
  <div class="welcome-dialog__greeting">
    Welcome to YepHome!
  </div>
  <div class="welcome-dialog__introduction">
    Before we get started please fill out some basic info about yourself so we can get to know you better.
  </div>
  <div class="welcome-dialog__form-container">
    <form [formGroup]="formGroup"
          #formDirective="ngForm"
          class="welcome-dialog__form">
      <div fxLayout="row">
        <div fxFlex="50">
          <div class="welcome-dialog__label">First Name*</div>
          <input
            class="welcome-dialog__input"
            formControlName="firstName">
        </div>
        <div fxFlex="50">
          <div class="welcome-dialog__label">Last Name*</div>
          <input
            class="welcome-dialog__input"
            formControlName="lastName">
        </div>
      </div>
      <div fxLayout="row" style="margin-top: 1rem">
        <div fxFlex="50">
          <div class="welcome-dialog__label">Company Name</div>
          <input
            class="welcome-dialog__input"
            formControlName="companyName">
        </div>
        <div fxFlex="50">
          <div class="welcome-dialog__label">ABN</div>
          <input
            class="welcome-dialog__input"
            formControlName="abn">
        </div>
      </div>
    </form>
  </div>
  <div class="welcome-dialog__button-container"
       fxLayout="row"
       fxLayoutAlign="end center">
    <button
      class="welcome-dialog__submit-button"
      mat-raised-button
      [ngStyle]="{'background-color': isLoading ? 'grey' : '#2142FF'}"
      [disabled]="isLoading"
    (click)="onSubmit()">Submit
    </button>
  </div>
</div>
